<div class="product-card" *ngIf="product">
  <div class="header">
    <a [routerLink]="['/' + themeService.brand, 'product', product.sku]">
      <img
        [src]="product.media | productImageURL: settingNames.ProductImageLarge"
        [alt]="product.sku"
        class="img-fluid"
        vwProductImageFallback
      />
    </a>

    <ng-container *ngIf="product.isPackage">
      <span *ngIf="!product.assembledAndReady" class="product-message">
        {{ "productSubset" | translate }}
      </span>
      <span *ngIf="product.assembledAndReady" class="product-message">
        {{ "assembledAndReady" | translate }}
      </span>
    </ng-container>

    <span *ngIf="!!product.isNew" class="product-message">
      {{ "news" | translate }}
    </span>

    <div
      class="product-message product-message--campaign"
      *ngIf="product.isCampaign && !!product.campaign"
    >
      <span class="campaign-title">{{ "campaign" | translate }}</span>
      <span class="campaign-dates"
        >{{ product.campaign.startDate | date: "d LLL" }} -
        {{ product.campaign.endDate | date: "d LLL" }}</span
      >
    </div>
  </div>

  <div class="content hyphenate">
    <vw-link
      [routerLinks]="['/' + themeService.brand, 'product', product.sku]"
      [text]="
        product.media
          | media: mediaCategoryTypeNames.ProductName : mediaTypes.Text
      "
      [anchorTagClass]="'bold h4 mb-3'"
    >
    </vw-link>

    <div>
      <span *ngIf="product.trademark" class="d-block bold">{{
        product.trademark
      }}</span>
      <span class="d-block">{{ product.sku }}</span>
    </div>

    <ng-content></ng-content>

    <div
      *ngIf="product.price && product.price.salesPrice != null"
      class="prices"
    >
      <div *ngIf="product.isCampaign && !!product.campaign; else noCampaign">
        <div class="campaign-percentage">
          {{ product.price.adjustmentPercentage | campaignDiscount }}
        </div>
        <div class="campaign-price">
          <span class="price">{{ product.price.salesPrice | price }}</span>
          <div
            *ngIf="!!product.price.listPrice"
            class="d-flex align-items-center"
          >
            <span class="campaign-original-price">{{
              product.price.listPrice | price
            }}</span>
            <i
              class="fal fa-info-circle"
              title="{{ 'price.latest' | translate }}"
            ></i>
          </div>
        </div>
      </div>
      <ng-template #noCampaign>
        <span class="price">{{ product.price.salesPrice | price }}</span>
      </ng-template>

      <span class="monthly-price">{{
        product.price.salesPrice | price: true
      }}</span>
    </div>
  </div>

  <div class="footer">
    <div class="actions">
      <div class="row g-0 align-items-center">
        <div class="col-6 z-2">
          <vw-button
            [primary]="true"
            [text]="'product.add' | translate"
            [icon]="'fal fa-shopping-cart ms-1'"
            [disabled]="
              !(product | productAddable: shoppingCartService.shoppingCart)
            "
            (click$)="createShoppingCartItem(product)"
            *ngIf="shoppingCartService.shoppingCart"
          ></vw-button>
        </div>
        <div class="col-6 z-2">
          <div class="d-flex justify-content-center">
            <vw-link
              [text]="'readMore' | translate"
              [icon]="'fal fa-long-arrow-right'"
              [routerLinks]="['/' + themeService.brand, 'product', product.sku]"
            ></vw-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
